import { getElementId } from '../../../../common/elements/utils/elementPropertyUtils';

import getQueryRegex, { QueryMode } from '../../../../common/utils/getQueryRegex';
import elementContainsSearchQuery from './elementContainsSearchQuery';

export default ({ query, elements, comments }) => {
    if (!query) return [];

    const queryRegEx = getQueryRegex(query, QueryMode.PHRASE);

    return (
        elements
            .valueSeq()
            // Find matching elements
            .filter(elementContainsSearchQuery({ queryRegEx, comments }))
            // Return their id
            .map(getElementId)
            .toJS()
    );
};
